import apiService from '@/utils/api-client'
import {formatQueryStringForObject} from '@/utils/format-query'
import { isPromoDismissed } from '@/services/promo-campaign'

export default {
  // eslint-disable-next-line no-unused-vars
  async fetchPlans({ commit }) {
    try {
      const data = await apiService.get(`billing/plans`)
      return data
    } catch (error) {
      console.error(error)
    }
  },
  // eslint-disable-next-line no-unused-vars
  async fetchCurrentPlan({ commit }) {
    try {
      const { data, success } = await apiService.get(`billing/subscription`)

      if (success && data) {
        commit('SET_CURRENT_PLAN', data)
        return { data, success }
      }
    } catch (error) {
      console.error(error)
    }
  },
  // eslint-disable-next-line no-unused-vars
  async createCheckout({ commit }, { planTier, billingCycle, paymentMethod = 'card', startTrial = false, promotionCode, returnUrl }) {
    try {
      const body = {
        planTier,
        billingCycle: billingCycle === 'month' ? 'monthly' : billingCycle ,
        paymentMethod,
        startTrial,
        ...(promotionCode ? { promotionCode } : {}),
        ...(returnUrl ? { returnUrl } : {}),
      }
      return await apiService.post(`/billing/checkout`, body)
    } catch (error) {
      console.error(error)
    }
  },
  // eslint-disable-next-line no-unused-vars
  async syncCheckout({ commit }, { sessionId }) {
      try {
        const body = {
          sessionId
        }
        return await apiService.post(`/billing/sync-checkout`, body)
      } catch (error) {
          console.error(error)
      } 
  },
  // eslint-disable-next-line no-unused-vars
  async cancelSubscription({ commit }) {
    try {
      return await apiService.post(`/billing/cancel`)
    } catch (error) {
      console.error(error)
    }
  },
   // eslint-disable-next-line no-unused-vars
  async reactivateSubscription({ commit }) {
    try {
      return await apiService.post(`/billing/reactivate`)
    } catch (error) {
      console.error(error)
    }
  },
  // eslint-disable-next-line no-unused-vars
  async changePlan({ commit }, { targetTier, targetCycle, returnUrl }) {
    try {
      return await apiService.post(`/billing/change-plan`, {
        targetTier,
        targetCycle: targetCycle === 'month' ? 'monthly' : targetCycle,
        ...(returnUrl ? { returnUrl } : {}),
      })
    } catch (error) {
      console.error(error)
    }
  },
  // eslint-disable-next-line no-unused-vars
  async activateTrial({ commit }, { returnUrl } = {}) {
    try {
      return await apiService.post(`/billing/activate-trial`, {
        ...(returnUrl ? { returnUrl } : {}),
      })
    } catch (error) {
      console.error(error)
    }
  },
  // eslint-disable-next-line no-unused-vars
  async refreshQuota({ commit }, { returnUrl } = {}) {
    try {
      return await apiService.post(`/billing/refresh-quota`, {
        ...(returnUrl ? { returnUrl } : {}),
      })
    } catch (error) {
      console.error(error)
    }
  },
  // eslint-disable-next-line no-unused-vars
  async cancelDowngrade({ commit }) {
    try {
      return await apiService.post(`/billing/cancel-downgrade`)
    } catch (error) {
      console.error(error)
    }
  },
  // eslint-disable-next-line no-unused-vars
  async getBillingAccess({ commit }) {
    try {
      return await apiService.get(`/billing/access`)
    } catch (error) {
      console.error(error)
    }
  },
  // eslint-disable-next-line no-unused-vars
  async createBillingPortalSession({ commit }, { returnUrl }) {
    try {
      return await apiService.post(`/billing/portal`, {
        returnUrl,
      })
    } catch (error) {
      console.error(error)
    }
  },
  // eslint-disable-next-line no-unused-vars
  async getPackages({ commit }) {
    try {
      const data = await apiService.get(`packages`)
      return data
    } catch (error) {
      console.error(error)
    }
  },
  // eslint-disable-next-line no-unused-vars
  setCustomPackage({ commit }, { tokens = undefined, price = undefined }) {
    try {
      return apiService.post(`/packages/custom`, { tokens, price })
    } catch (error) {
      console.error(error)
    }
  },
  // eslint-disable-next-line no-unused-vars
  buyPackage({ commit }, { packageId, paymentMethod, returnUrl }) {
    try {
      return apiService.post(`payments/purchase/${packageId}`, {
        paymentMethod,
        ...(returnUrl ? { returnUrl } : {}),
      })
    } catch (error) {
      console.error(error)
    }
  },
  // eslint-disable-next-line no-unused-vars
  checkCoinifyStatus({ commit }, { id }) {
    try {
      return apiService.get(`payments/coinify/status`, {
        params: { id },
      })
    } catch (error) {
      console.error(error)
    }
  },
  buyCustomPackage(
    // eslint-disable-next-line no-unused-vars
    { commit },
    { paymentMethod, tokens = undefined, price = undefined },
  ) {
    try {
      return apiService.post(`/payments/purchase/custom`, {
        paymentMethod,
        tokens,
        price,
      })
    } catch (error) {
      console.error(error)
    }
  },

  async getPaymentHistoryList(
    // eslint-disable-next-line no-unused-vars
    { commit },
    { lazyParams: { pageSize, pageNumber, sort } },
  ) {
    try {
      const data = apiService.get(
        `/payments/history?${formatQueryStringForObject(sort, 'sort')}`,
        {
          params: { pageSize, pageNumber },
        },
      )
      return data
    } catch (error) {
      console.error(error)
    }
  },
  // eslint-disable-next-line no-unused-vars
  async getPromoCampaign({ commit }) {
    try {
      const { data, success } = await apiService.get('billing/promo-campaign')
      if (success && data) {
        commit('SET_PROMO_CAMPAIGN', data)
        return { data, success }
      }
    } catch (error) {
      console.error(error)
    }
  },
  // eslint-disable-next-line no-unused-vars
  async fetchPromoCampaignIfNeeded({ state, dispatch }) {
    if (state.promoCampaign !== null) {
      return { data: state.promoCampaign, success: true }
    }
    if (isPromoDismissed()) {
      return { success: false }
    }
    return await dispatch('getPromoCampaign')
  },
  // eslint-disable-next-line no-unused-vars
  checkAndShowPromoModal({ dispatch, rootGetters }) {
    const campaign = rootGetters['payment/getPromoCampaignData']
    if (!campaign) return
    const PromoCampaignModal = require('@/pages/payment/promo-campaign/PromoCampaignModal.vue').default
    dispatch('modal/openModal', { component: PromoCampaignModal, props: { campaign } }, { root: true })
  },
}
